/**
 * De taalbundels van de SPA, en wat daarvan afgeleid is — zónder i18next te starten.
 *
 * WAAROM DIT EEN EIGEN BESTAND IS. `./index.ts` initialiseert i18next als bijwerking
 * van het importeren. Een scherm dat alleen de lijst met talen nodig had en die daar
 * vandaan haalde, zette daarmee i18n aan in elke test van dat scherm: die zagen
 * opeens echte teksten in plaats van de sleutels waarop ze toetsen. Deze module heeft
 * geen bijwerking, dus importeer hiervandaan wie alleen wil weten wélke talen er zijn.
 *
 * Eén bron voor "welke talen kent de SPA": een nieuwe taal = JSON-bestand in
 * ./locales/ + één regel in `bundles`. Al het overige (resources, taaldetectie,
 * SpaLocale-type, de taalkiezer, de pariteit-test) leidt hiervan af —
 * localeParity.test.ts faalt als een bundel-bestand hier niet geregistreerd is (of
 * andersom).
 */
import en from './locales/en.json';
import nl from './locales/nl.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

export const bundles = { en, nl, de, fr } as const;

/**
 * Een immutable deep-clone-snapshot, zodat per-tenant overrides (ADR-0021) bij
 * delete/reset terug kunnen vallen op de canonieke platform-vertaling zonder reload.
 */
export const i18nDefaults = Object.fromEntries(
  Object.entries(bundles).map(([code, bundle]) => [
    code,
    JSON.parse(JSON.stringify(bundle)) as Record<string, unknown>,
  ]),
) as Record<keyof typeof bundles, Record<string, unknown>>;

export type SpaLocale = keyof typeof bundles;

/** Alle SPA-talen, afgeleid van de geregistreerde bundels. */
export const SPA_LOCALES = Object.keys(bundles) as SpaLocale[];
